export default __webpack_public_path__ + "static/media/IMG_20190613_174925.ef06d00e.jpg";